// extracted by mini-css-extract-plugin
export default {"container":"RestaurantsList_container__hXi2X","restaurant":"RestaurantsList_restaurant__MXgIM"};